export enum FilesEndpointTypes {
  SERVICE = 'Service',
  ENDPOINT = 'Endpoint',
  DATABASE = 'Database',
  COLLABORATION = 'Collaboration',
  COMMUNICATION = 'Communication',
  SOURCE_CONTROL = 'Source Control',
}
